import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-multi-select-dropdown',
  standalone: true,
  imports: [CommonModule, NgMultiSelectDropDownModule, FormsModule],
  templateUrl: './multi-select-dropdown.component.html',
  styleUrl: './multi-select-dropdown.component.scss'
})
export class MultiSelectDropdownComponent implements AfterViewChecked {
  @Input() placeHolderTitle: string = "";
  @Input() dropdownList: any = [];
  @Input() selectedItems: any = [];
  @Input() dropdownSettings: any = {};
  @Input() clearfilter : boolean = false
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();
  isToggle: boolean = false;
  ngOnInit() {
   
  }


  @Output() onApply: EventEmitter<any> = new EventEmitter();
@Output() onReset: EventEmitter<void> = new EventEmitter();

onResetClick() {
  this.selectedItems = [];
  this.onReset.emit(); // notify parent if needed
}

onApplyClick() {
  this.onApply.emit(this.selectedItems); // send selected items to parent
}
  ngAfterViewChecked() {
    
    
    setTimeout(() => {
      let listItems = document.querySelectorAll(".category-filter .multiselect-item-checkbox");
      if(listItems.length > 0){
        listItems.forEach((element:any, index:any) => {
          if(this.dropdownList?.length && this.dropdownList[index] && this.dropdownList[index].isNested == true){
              element.style = "padding-left: 38px !important";
          }
        });
      }
      }, 900);
  }

  ngOnChanges () {
    if(this.clearfilter == true) {
      this.selectedItems = [];
      this.passSelectedItems();
    }
  
  }
  
  onItemSelect(item: any, dropdownList: any) {
    if(item.id == 0){
      this.selectedItems=[...dropdownList];
    }else{
    dropdownList.forEach((dropdownItem: any) => {
      if(item.name == dropdownItem.name && dropdownItem?.subcategories?.length > 0) {
        dropdownItem.subcategories.forEach((subDropdownItem: any) => {
          this.selectedItems.push(subDropdownItem);
        })
      }
    })

    this.selectedItems.push(item);
   }
   
    this.passSelectedItems();
  }

  onItemDeSelect(item:any, dropdownList: any){
    let index = null;
    if(item.id == 0){
      this.selectedItems=[];
    }else{
    dropdownList.forEach((dropdownItem: any) => {
      if(dropdownItem?.subcategories?.length > 0) {
        if(item.name == dropdownItem.name) {
          dropdownItem?.subcategories.forEach((subDropdownItem: any) => {
            index = this.selectedItems.findIndex((data:any) => data.name == subDropdownItem.name);
            if(index != -1){
              this.selectedItems.splice(index, 1);
            }
          })
        } else {
          dropdownItem?.subcategories.forEach((subDropdownItem: any) => {
            if(subDropdownItem.name == item.name) {
              index = this.selectedItems.findIndex((data:any) => data.name == dropdownItem.name);
              if(index != -1){
                this.selectedItems.splice(index, 1);
              }
            }
          })
        }
      }
    })

    index = this.selectedItems.findIndex((data:any) => data[this.dropdownSettings.idField] == item[this.dropdownSettings.idField]);
    if(index != -1){
      this.selectedItems.splice(index, 1);
    }
  }
    
    this.passSelectedItems();
  }

  passSelectedItems(){
    if(!this.clearfilter) {
      this.onSelectionChange.emit({value: [...new Map(this.selectedItems.map((item:any) =>
        [item[this.dropdownSettings.idField], item])).values()]});
    }
  
      
  }

  toggleDropdownState(event:any) {
    this.isToggle = !this.isToggle; // Toggle the state
  }
  handleOutsideClick(event: MouseEvent) {
    const dropdownContainer = document.querySelector('.custom-multi-dropdown-container');
    if (dropdownContainer && !dropdownContainer.contains(event.target as Node)) {
      this.isToggle = false; // Close dropdown if clicked outside
    }
  }
}
